import React, { useMemo } from 'react';

const TrainLogo = ({trainCompany}) => {
    const logos = useMemo(()=>({
        Italo: '/trainLogo/italo.png',
        Trenitalia: '/trainLogo/trenitalia.png',
    }),[]);

    const logoSrc = logos[trainCompany] || '/trainLogo/trenitalia.png';

    return <img src={logoSrc} alt={`${trainCompany} Logo`} className="lg:w-20 w-10 h-full rounded-lg" loading="lazy" />;
};

export default TrainLogo;